import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, setUserProperties } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDh-2-dJLI24ODJRCBYysrLeTe5ioKs2dw",
  authDomain: "blupon-30b1a.firebaseapp.com",
  projectId: "blupon-30b1a",
  storageBucket: "blupon-30b1a.firebasestorage.app",
  messagingSenderId: "605404363152",
  appId: "1:605404363152:web:606537400abd16bed01b15",
  measurementId: "G-HB5XEC1788"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export { db, analytics, setUserProperties };